import { render, staticRenderFns } from "./PMMetode.vue?vue&type=template&id=845e82f4"
import script from "./PMMetode.vue?vue&type=script&lang=js"
export * from "./PMMetode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports